const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

// ─── Breadcrumbs последних запросов (для формы обратной связи) ──────────────────
// Кольцевой буфер строк вида "METHOD /path -> status". НЕ содержит тел запросов и
// НИКОГДА не содержит X-Telegram-Init-Data. Читается feedbackContext.js.
const MAX_BREADCRUMBS = 15;
const recentRequests = [];

const pushBreadcrumb = (method, endpoint, status) => {
  // Не логируем сам эндпоинт фидбека, чтобы не зашумлять контекст.
  if (endpoint.startsWith('/api/feedback')) return;
  // Отрезаем query-строку — в ней могут быть параметры, тела не пишем в любом случае.
  const path = endpoint.split('?')[0];
  recentRequests.push(`${method} ${path} -> ${status}`);
  if (recentRequests.length > MAX_BREADCRUMBS) recentRequests.shift();
};

/** Последние запросы (копия) — для технического контекста обращения. */
export const getRecentRequests = () => [...recentRequests];

/**
 * Получить initData из Telegram WebApp
 */
const getInitData = () => {
  if (window.Telegram?.WebApp?.initData) {
    return window.Telegram.WebApp.initData;
  }
  // Для разработки вне Telegram
  return process.env.REACT_APP_DEV_INIT_DATA || 'non-telegram-mode';
};

/**
 * Базовая функция для fetch-запросов с автоматической подстановкой заголовков
 */
const apiRequest = async (endpoint, options = {}) => {
  const initData = getInitData();

  const headers = {
    'Content-Type': 'application/json',
    ...(initData && { 'X-Telegram-Init-Data': initData }),
    ...options.headers,
  };

  const method = (options.method || 'GET').toUpperCase();

  let response;
  try {
    response = await fetch(`${API_BASE_URL}${endpoint}`, {
      ...options,
      headers,
    });
  } catch (networkErr) {
    // Сетевой сбой (нет соединения и т.п.) — тоже полезный след для диагностики.
    pushBreadcrumb(method, endpoint, 'network-error');
    throw networkErr;
  }

  pushBreadcrumb(method, endpoint, response.status);

  if (!response.ok) {
    let errorMessage = `Ошибка ${response.status}`;
    let errorData = null;
    try {
      errorData = await response.json();
      errorMessage = errorData.message || errorData.error || errorMessage;
    } catch {
      // ignore parse error
    }

    // Если бэкенд вернул "Hash is missing" — initData пустой или невалидный.
    // Перезагружаем страницу: Telegram переинициализирует WebApp с новым initData.
    // Это безопаснее чем кэшировать старый токен, и лучше чем показывать
    // незакрываемую ошибку (кнопка retry не помогает — initData всё ещё пустой).
    if (response.status === 403 && errorData?.message === 'Hash is missing') {
      window.location.reload();
      // Бросаем ошибку чтобы текущий запрос не продолжился до reload
      const error = new Error('Session expired, reloading...');
      error.status = 403;
      throw error;
    }

    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  // 204 No Content
  if (response.status === 204) {
    return null;
  }

  // Проверяем, есть ли тело в ответе
  const contentLength = response.headers.get('content-length');
  const contentType = response.headers.get('content-type');
  
  if (contentLength === '0' || !contentType?.includes('application/json')) {
    return null;
  }

return response.json();
};

export default apiRequest;